interface ErrorStateProps {
  error: Error | null;
  onRetry?: () => void;
  className?: string;
  title?: string;
}

/**
 * Componente ErrorState - Muestra un estado de error con opción de reintentar
 */
export const ErrorState = ({
  error,
  onRetry,
  className = 'h-64',
  title = 'Error al cargar datos'
}: ErrorStateProps) => {
  if (!error) return null;

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="text-center">
        <div className="text-error text-4xl mb-4">⚠️</div>
        <h3 className="text-lg font-semibold text-title mb-2">
          {title}
        </h3>
        <p className="text-complementary-text mb-4">{error.message}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="px-4 py-2 bg-primary text-btn-text rounded hover:bg-hover-press transition-colors"
            data-testid="error-retry-button"
          >
            Reintentar
          </button>
        )}
      </div>
    </div>
  );
};
